import { combineReducers } from 'redux';
import { login } from 'redux/reducers/auth/loginReducer';

const authReducers = combineReducers({
  login,
});

export default authReducers;
